/**
 * Constants used in the geom library
 * @module
 */

export const PI = Math.PI;
export const HALF_PI = PI / 2;
export const ONE_AND_HALF_PI = 3 * HALF_PI;
export const TWO_PI = 2 * PI;
export const ZERO_EPSILON = 1e-10;
export const PARAM_EPSILON = 1e-10;
export const DIST_EPSILON = 1e-6;
export const DIST_EPSILON_32BIT = 2e-4; // 32-bit floats have about 7 decimal digits of precision, so we use a larger epsilon for 32-bit operations. This epsilon is ok for numbers up to 1000.
export const DIST_EPSILON_SQUARED = DIST_EPSILON * DIST_EPSILON;
export const ANGLE_EPSILON = 1e-10;
export const COMPACTNESS_EPSILON = 0.01;
export const ONE_MINUS_DIST_EPSILON = 1.0 - DIST_EPSILON;
export const ONE_PLUS_DIST_EPSILON = 1.0 + DIST_EPSILON;
export const DIST_Z_FIGHT = 0.1;

export enum WindingDir {
  CW = "CW",
  CCW = "CCW",
}

export enum Line2Side {
  LEFT,
  RIGHT,
  COLLINEAR,
}

export enum Line2CollinearOverlap {
  NONE,
  POINT,
  LINE1_INSIDE_LINE2,
  LINE2_INSIDE_LINE1,
  PARTIAL,
  FULL,
}
